import type { SVGProps } from 'react';

/** Figma: Discovery — map-pinned (21125:166100) */
const MetropolisLocations = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    fill="none"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      d="M10.8925 17.5H6.25496C5.99287 17.5001 5.73744 17.5826 5.5248 17.7358C5.31215 17.889 5.15304 18.1052 5.06996 18.3537L2.56496 25.8538C2.50216 26.0416 2.48491 26.2418 2.51465 26.4376C2.54439 26.6335 2.62025 26.8195 2.73598 26.9803C2.85172 27.141 3.00401 27.272 3.18031 27.3624C3.3566 27.4527 3.55185 27.4999 3.74996 27.5H26.25C26.4479 27.4998 26.643 27.4527 26.8192 27.3624C26.9953 27.2721 27.1475 27.1412 27.2632 26.9806C27.379 26.82 27.4549 26.6342 27.4847 26.4385C27.5146 26.2428 27.4975 26.0428 27.435 25.855L24.935 18.355C24.852 18.106 24.6928 17.8894 24.4799 17.7359C24.267 17.5825 24.0112 17.4999 23.7487 17.5H19.1087M22.5 10C22.5 14.5162 17.6637 19.2863 15.7587 20.9938C15.5408 21.1602 15.2742 21.2504 15 21.2504C14.7257 21.2504 14.4591 21.1602 14.2412 20.9938C12.3375 19.2863 7.49995 14.5162 7.49995 10C7.49995 8.01088 8.29013 6.10322 9.69665 4.6967C11.1032 3.29018 13.0108 2.5 15 2.5C16.9891 2.5 18.8967 3.29018 20.3033 4.6967C21.7098 6.10322 22.5 8.01088 22.5 10ZM17.5 10C17.5 11.3807 16.3807 12.5 15 12.5C13.6192 12.5 12.5 11.3807 12.5 10C12.5 8.61929 13.6192 7.5 15 7.5C16.3807 7.5 17.5 8.61929 17.5 10Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MetropolisLocations;
